import React, { Component } from "react";
import { Card, Table, Button, message, Icon, Spin, Tooltip } from "antd";
import moment from "moment";
import axios from "axios";
import { Translate } from "react-translated";
import F from "../../Functions";
import DataHandler from "../../utils/DataHandler";
import ConfirmationModal from "../../components/confirmation-modal";
import { get_label_from_value, TYPE_OF_CALL } from "../../utils/Constants";
import { MOVE_BFILES_TO_REVIEW_OR_FOLLOW_UP_V1, MOVE_BFILES_TO_REVIEW_OR_FOLLOW_UP_V2 } from "../../utils/Api_enums";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class DuplicateFiles extends Component {
  state = {
    loading: false,
    bfiles: [],
    selectedRowIndexes: [], // [1,3] ==>> indexes
    selectedRowBFileData: [], // []
    showMovedBFileToDiffQueueConfirmationModal: false,
    showDiscardBFilesConfirmationModal: false,
    action: "",
    type_of_call: (this.props && this.props.location &&
      this.props.location.state && this.props.location.state.type_of_call
      && this.props.location.state.type_of_call) || "",
  };

  componentDidMount() {
    this.getDuplicateData();

    DataHandler.setDuplicateDataCallback(this.getDuplicateData);
  }


  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.location.state !== this.props.location.state) {
      this.setState({ type_of_call: this.props.location.state.type_of_call })
    }
  }

  componentWillUnmount() {
    // reset
    DataHandler.setAdminCsvDuplicateData(null);
    DataHandler.setDuplicateDataCallback(null);
  }

  getDuplicateData = () => {
    // get data from temp instance and set in state
    const csvDuplicateData = DataHandler.getAdminCsvDuplicateData();

    if (csvDuplicateData && csvDuplicateData.data) {
      this.setState({ bfiles: csvDuplicateData.data }, () =>
        // scroll up smoothly
        this.smoothScroll()
      );
    }
  };

  // componentDidUpdate(prevProps, prevState) {
  //   // get data from temp instance and set in state
  //   const csvDuplicateData = DataHandler.getAdminCsvDuplicateData();

  //   if (csvDuplicateData && csvDuplicateData.data) {
  //     this.setState({ bfiles: csvDuplicateData.data }, () =>
  //       // scroll up smoothly
  //       this.smoothScroll()
  //     );
  //   }
  // }

  smoothScroll = () => {
    const root = document.getElementById("root");
    root.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  onSelectChange = (selectedRowKeys) => {
    const { bfiles } = this.state;

    // Add selected bfile rows to state
    const selectedRowBFileData = [];
    for (let i = 0; i < selectedRowKeys.length; i++) {
      const selectedRowIndex = selectedRowKeys[i];
      selectedRowBFileData.push(bfiles[selectedRowIndex]); // add complete object
    }

    this.setState({
      selectedRowIndexes: selectedRowKeys,
      selectedRowBFileData,
    });
  };

  removeSelectedBFilesFromUI = () => {
    const { bfiles, selectedRowBFileData } = this.state;
    /** remove all bfiles from the UI list which have been moved to different queue call */
    let currentBFiles = [...bfiles];

    for (let i = 0; i < selectedRowBFileData.length; i++) {
      const bFile_id = selectedRowBFileData[i].id;

      currentBFiles = currentBFiles.filter((bfile) => {
        return bfile.id !== bFile_id;
      });
    }

    this.setState({
      loading: false,
      selectedRowIndexes: [],
      selectedRowBFileData: [],
      bfiles: currentBFiles,
      action: "",
    });
  };

  handleResponse = (res) => {
    // reset notification
    message.destroy();

    // show success or error message from server
    if (res.data.success) {
      message.success(res.data.message);

      this.removeSelectedBFilesFromUI();
    } else {
      message.error(res.data.message);

      this.setState({
        loading: false,
      });
    }
  };

  //v1
  // moveCustomerToDifferentCallQueue = () => {
  //   const { selectedRowBFileData, action } = this.state;

  //   const csvDuplicateData = DataHandler.getAdminCsvDuplicateData();

  //   // add action to the existing payload
  //   csvDuplicateData["action"] = action;

  //   // replace bfiles with the newly selected bfiles to move different queue call dashboards
  //   csvDuplicateData["data"] = selectedRowBFileData;

  //   this.setState({ loading: true });

  //   axios
  //     .post(MOVE_BFILES_TO_REVIEW_OR_FOLLOW_UP_V1, csvDuplicateData)
  //     .then((res) => this.handleResponse(res))
  //     .catch((error) => {
  //       this.setState({
  //         loading: false,
  //       });
  //     });
  // };


  //v2
  // moveCustomerToDifferentCallQueue = () => {
  //   const { selectedRowBFileData, action } = this.state;

  //   const csvDuplicateData = DataHandler.getAdminCsvDuplicateData();

  //   // add action to the existing payload
  //   csvDuplicateData["action"] = action;

  //   // replace bfiles with the newly selected bfiles to move different queue call dashboards
  //   csvDuplicateData["data"] = selectedRowBFileData;


  //   csvDuplicateData["data"] = csvDuplicateData.data.map((e) => ({
  //     id: e.id,
  //     fs_effective_date: e.fs_effective_date,
  //     fs_expiration_date: e.fs_expiration_date,
  //     rs_review_month: e.rs_review_month,
  //     type_of_call : e.type_of_call_old,
  //     sub_type_of_call : e.sub_type_of_call_old,
  //     bfile_sub: e.bfile_sub && e.bfile_sub.length > 0
  //       ? [{ id: e.bfile_sub[0].id }]
  //       : []
  //   }));

  //   this.setState({ loading: true });

  //   axios
  //     .post(MOVE_BFILES_TO_REVIEW_OR_FOLLOW_UP_V2, csvDuplicateData)
  //     .then((res) => this.handleResponse(res))
  //     .catch((error) => {
  //       this.setState({
  //         loading: false,
  //       });
  //     });
  // };


  //v3
  moveCustomerToDifferentCallQueue = () => {
    const { selectedRowBFileData, action } = this.state;

    const csvDuplicateData = DataHandler.getAdminCsvDuplicateData();

    // add action to the existing payload
    csvDuplicateData["action"] = action;

    // replace bfiles with the newly selected bfiles to move different queue call dashboards
    csvDuplicateData["data"] = selectedRowBFileData;

    const file = new Blob([JSON.stringify(csvDuplicateData)], {
      type: "application/json"
    });

    const fileToSend = new File([file], "data.json");

    const formData = new FormData();
    formData.append("file", fileToSend);

    this.setState({ loading: true });

    axios
      .post(MOVE_BFILES_TO_REVIEW_OR_FOLLOW_UP_V1, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => this.handleResponse(res))
      .catch((error) => {
        this.setState({ loading: false });
      });
  };



  showConfirmationModal = (action) => {
    this.setState({
      action,
      showMovedBFileToDiffQueueConfirmationModal: true,
    });
  };

  onConfirmedMoveCustomerModal = () => {
    this.setState({ showMovedBFileToDiffQueueConfirmationModal: false }, () => {
      this.moveCustomerToDifferentCallQueue();
    });
  };

  onCancelModal = () => {
    this.setState({ showMovedBFileToDiffQueueConfirmationModal: false });
  };

  showDiscardBFilesnModal = () => {
    this.setState({
      showDiscardBFilesConfirmationModal: true,
    });
  };

  onDiscardBFilesConfirmedModal = () => {
    this.setState({ showDiscardBFilesConfirmationModal: false }, () => {
      this.removeSelectedBFilesFromUI();
    });
  };

  onDiscardBFilesCancelModal = () => {
    this.setState({ showDiscardBFilesConfirmationModal: false });
  };

  showActionButtonsToMoveCustomersToCallQueue = () => {
    const { selectedRowIndexes } = this.state;

    return selectedRowIndexes.length > 0 ? (
      <div className="toolbarButtons">
        <Button
          type="default"
          onClick={() => this.showConfirmationModal("Review")}
          disabled={this.state.type_of_call !== 'Review'}
          className="borderRadius-28"
        >
          <Translate text={`Move To Review Scheduler`} />
        </Button>
        <Button
          type="default"
          onClick={() => this.showConfirmationModal("Prospect")}
          disabled={this.state.type_of_call !== 'Prospect'}
          className="borderRadius-28"
        >
          <Translate text={`Move To Lead`} />
        </Button>
        <Button
          type="default"
          onClick={() => this.showConfirmationModal("FollowUp")}
          disabled={this.state.type_of_call !== 'FollowUp'}
          className="borderRadius-28"
        >
          <Translate text={`Move To Opportunity`} />
        </Button>
        <Button type="default" onClick={this.showDiscardBFilesnModal}
          className="borderRadius-28"
        >
          <Translate text={`Discard`} />
        </Button>
      </div>
    ) : null;
  };

  render() {
    const { loading, selectedRowIndexes, bfiles, action } = this.state;

    let columns = [
      {
        title: <Translate text={"Name"} />,
        dataIndex: "name",
        key: "name",
      },
      {
        title: <Translate text={"Created Date"} />,
        dataIndex: "created_on",
        key: "created_on",
      },
      {
        title: <Translate text={"Agency Name"} />,
        dataIndex: "agency_name",
        key: "agency_name",
      },
      {
        title: <Translate text={"Phone"} />,
        dataIndex: "phone",
        key: "phone",
      },
      {
        title: <Translate text={"Email"} />,
        dataIndex: "email",
        key: "email",
      },
      {
        title: <Translate text={"Type of Call"} />,
        dataIndex: "type_of_call",
        key: "type_of_call",
      },
      {
        title: <Translate text={"Sub-Type of Call"} />,
        dataIndex: "sub_type_of_call",
        key: "sub_type_of_call",
      },
    ];

    const data = [];
    for (let i = 0; i < bfiles.length; i++) {
      let bfile = bfiles[i];

      let bfile_name = bfile.first_name + " " + bfile.last_name;

      data.push({
        name: bfile_name,
        created_on: moment(new Date(bfile.date)).format("MM/DD/YYYY"),
        agency_name: bfile.agency_name,
        phone: F.phone_format(bfile.phone),
        email: bfile.email,
        type_of_call: TYPE_OF_CALL[`${bfile.type_of_call_old}`],
        sub_type_of_call: (<div style={{ width: 150 }}>
          <Tooltip title={get_label_from_value(bfile.sub_type_of_call_old, 'label', bfile.type_of_call_old)}>
            <div style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
              {get_label_from_value(bfile.sub_type_of_call_old, 'label', bfile.type_of_call_old)}
            </div>
          </Tooltip>
        </div>)
      });
    }

    const rowSelection = {
      selectedRowKeys: selectedRowIndexes,
      onChange: this.onSelectChange,
    };

    return (
      <Spin indicator={antIcon} spinning={loading}>
        <div>
          <Card
            type="inner"
            title={
              <div style={{ paddingTop: 7 }}>
                <Translate text={`CSV Duplicate B Files`} />
              </div>
            }
            className="tableCard"
          // loading={loading}
          >
            {this.showActionButtonsToMoveCustomersToCallQueue()}
            <Table
              columns={columns}
              dataSource={data}
              bordered={false}
              pagination={false}
              rowSelection={rowSelection}
              locale={{ emptyText: "No Data To Show" }}
            />
          </Card>
          <ConfirmationModal
            showModal={this.state.showMovedBFileToDiffQueueConfirmationModal}
            title={`Move to ${TYPE_OF_CALL[action]}`}
            okText="Yes"
            cancelText="No"
            message={`Are you sure you want to move customer${selectedRowIndexes.length > 1 ? "s" : ""
              } to ${TYPE_OF_CALL[action]}?`}
            ok={this.onConfirmedMoveCustomerModal}
            cancel={this.onCancelModal}
          />
          <ConfirmationModal
            showModal={this.state.showDiscardBFilesConfirmationModal}
            title="Discard"
            okText="Yes"
            cancelText="No"
            message="Are you sure you want to discard?"
            ok={this.onDiscardBFilesConfirmedModal}
            cancel={this.onDiscardBFilesCancelModal}
          />
        </div>
      </Spin>
    );
  }
}

export default DuplicateFiles;



// WEBPACK FOOTER //
// ./src/scenes/DuplicateFiles/index.js